import { Divider, getIntrinsicElementProps, slot } from '@fluentui/react-components';
import { useCopilotMode } from '@fluentai/provider';
// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render CopilotMessageFooter.
 *
 * The returned state can be modified with hooks such as useCopilotMessageFooterStyles_unstable,
 * before being passed to renderCopilotMessageFooter_unstable.
 *
 * @param props - props from this instance of CopilotMessageFooter
 * @param ref - reference to root HTMLElement of CopilotMessageFooter
 */
export const useCopilotMessageFooter_unstable = (props, ref) => {
  const mode = useCopilotMode(props.mode);
  // We only need the divider in canvas mode and when the slots we need to differentiate are present
  const shouldShowDivider = mode === 'canvas' && !!props.responseCount && (!!props.feedback || !!props.aiDisclaimer);
  return {
    mode,
    components: {
      root: 'div',
      aiDisclaimer: 'span',
      content: 'div',
      divider: Divider,
      feedback: 'span',
      referenceList: 'div',
      referenceListToggle: 'span',
      responseCount: 'span',
      sensitivity: 'span',
      sensitivityDisclaimerContainer: 'span'
    },
    root: slot.always(getIntrinsicElementProps('div', {
      ref,
      ...props
    }), {
      elementType: 'div'
    }),
    content: slot.optional(props.content, {
      elementType: 'div',
      defaultProps: {
        children: props.children
      },
      renderByDefault: !!props.children
    }),
    responseCount: slot.optional(props.responseCount, {
      elementType: 'span'
    }),
    feedback: slot.optional(props.feedback, {
      elementType: 'span'
    }),
    aiDisclaimer: slot.optional(props.aiDisclaimer, {
      elementType: 'span'
    }),
    referenceList: slot.optional(props.referenceList, {
      elementType: 'div'
    }),
    referenceListToggle: slot.optional(props.referenceListToggle, {
      elementType: 'span'
    }),
    divider: slot.optional(shouldShowDivider ? props.divider : undefined, {
      elementType: Divider,
      defaultProps: {
        vertical: true
      },
      renderByDefault: shouldShowDivider
    }),
    sensitivity: slot.optional(props.sensitivity, {
      elementType: 'span'
    }),
    sensitivityDisclaimerContainer: slot.optional(props.sensitivityDisclaimerContainer, {
      elementType: 'span',
      renderByDefault: !!props.sensitivity || !!props.aiDisclaimer
    })
  };
};
//# sourceMappingURL=useCopilotMessageFooter.js.map